<template>
  <footer class="BottomColumnPage">
    <div>©2025 gotoyiwu.com All rights reserved.</div>
    <div>
      Yiwu, China is renowned for its high-quality products. The Yiwu China
      Small Commodities Market (also known as the Yiwu Wholesale Market) serves
      global customers by offering a wide range of high-quality goods through
      its robust online trading platform.
    </div>
    <div class="Link">
      <a
        class="PublicNetworkSecurity"
        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33070302100808"
      >
        浙公网安备33070302100808号
      </a>
      <a href="https://beian.miit.gov.cn">浙ICP备2024112555号-3</a>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.BottomColumnPage {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #dfdfdf;
  // border-top: 1px solid #767676;
  height: 10vh;
  // box-sizing: border-box;
  width: 100%;
  margin-top: auto;
  font-size: 11px;
  color: #666;
  .Link {
    display: flex;
    align-items: center;
  }
  .PublicNetworkSecurity {
    height: 30px;
    line-height: 30px;
    color: #939393;
    padding-left: 24px;
    display: inline-block;

    background: url('../../assets/img/indexicon.png') 0 -207px no-repeat;
  }
  a {
    font-size: 0.8vw;
    color: #ccc;
    cursor: pointer;
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
